<template>
    <section v-if="">
        <div class="alert alert-warning my-3" v-if="preview">
            <span v-if="showProration">
                By applying this change, you will be charged ${{
                    preview.amount_prorated.toFixed(2)
                }}.
            </span>
            <span v-else="">
                By applying this change, a prorated charge/credit will be applied to your next
                invoice.
            </span>
        </div>
        <div class="alert alert-warning font-italic my-3" v-else="">
            <i class="fa fa-spin fa-circle-o-notch mr-2"></i>
            Calculating updated charge...
        </div>
    </section>
</template>

<script>
import { permissions } from "../../plugins/permissions";

export default {
    name: "UpcomingInvoicePreview",
    props: ["subscription", "organization"],
    mixins: [permissions],
    data() {
        return {
            preview: null,
        };
    },
    computed: {
        showProration() {
            return (
                this.preview.amount_prorated &&
                this.preview.amount_prorated > 0 &&
                this.preview.quantity > this.subscription.quantity
            );
        },
    },
    methods: {
        getUpcomingInvoicePreview(add) {
            this.preview = null;
            if (!this.ccCanViewOrganization) return;
            axios
                .get(
                    `api/users/${this.$root.user.id}/subscription/preview?${
                        _.get(this.organization, "id", null)
                            ? `&organization=` + this.organization.id
                            : ``
                    }&quantity=${this.subscription ? this.subscription.quantity + add : ""}`
                )
                .then(r => {
                    this.preview = r.data;
                });
        },
    },
};
</script>

<style scoped></style>
